import React from 'react';
import { IButton } from '../../../@types/button';
import { ButtonIcon } from './styled.ButtonMediaUpload';
import { Upload } from './../../../common/icons/Upload';
import { Loading } from './../../../common/icons/Loading';

export function ButtonMediaUpload ({ title, onClick, loading }: IButton) {
  if (loading) {
    return (
      <ButtonIcon>
        <Loading />
      </ButtonIcon>
    );
  }
  return (
    <ButtonIcon onClick={onClick} disabled={loading}>
      <>
        <Upload />
        {title}
      </>
    </ButtonIcon>
  );
}
